//#region src/recommendations_first_load_visibility.ts
var RecommendationsFirstLoadVisibility = /* @__PURE__ */ function(RecommendationsFirstLoadVisibility) {
	RecommendationsFirstLoadVisibility["Hidden"] = "hidden";
	RecommendationsFirstLoadVisibility["OrderHistory"] = "order-history";
	RecommendationsFirstLoadVisibility["Predictions"] = "predictions";
	RecommendationsFirstLoadVisibility["PredictionsAndOrderHistory"] = "predictions-and-order-history";
	return RecommendationsFirstLoadVisibility;
}(RecommendationsFirstLoadVisibility || {});
//#endregion
export { RecommendationsFirstLoadVisibility };

//# sourceMappingURL=recommendations_first_load_visibility.js.map